
import { caseAssignmentService } from '../../services/caseAssignmentService';

/**
 * Store used for the assignments view/assignment map
 */
const assignment = {
	namespaced: true,
	actions: {

		/**
		 * Sets the value of the currently selected dwelling id for assignment view
		 * @param {*} context
		 * @param {*} data
		 */
		setDwellingId(context, data) {
			context.commit('setDwellingId', data);
		},

		/**
		 * Sets the value of the currently selected staff id for assignment view
		 * @param {*} context
		 * @param {*} data
		 */
		setStaffId(context, data) {
			context.commit('setStaffId', data);
		},

		/**
		 * Makes a request to the server to get geo json for the region in the assignments view
		 * and stores the response
		 * @param {*} context
		 * @param {*} param1 {studyCode: study id, region: region id}
		 * @returns geo json for the region
		 */
		fetchAssignmentGeoJson(context, { studyCode, region }) {
			return new Promise((resolve, reject) => {
				caseAssignmentService.loadGeoJson(studyCode, region).then(async function (response) {
					if (response && response.data) {
						context.commit('setAssignmentGeoJson', { data: response.data });
					}
					resolve(response.data);
				}).catch(async function (e) {
					console.log(e);
					reject(e);
				});
			})
		},

		/**
		 * Makes a request to the server to get the json for the region used ot render the lower tables
		 * in the assignments view
		 * @param {*} context
		 * @param {*} param1 {studyCode: study id, region: region id}
		 * @returns json for region
		 */
		fetchAssignmentTableJson(context, { studyCode, region }) {
			return new Promise((resolve, reject) => {
				caseAssignmentService.loadTablesJson(studyCode, region).then(async function (response) {
					if (response && response.data) {
						context.commit('setAssignmentTableJson', { data: response.data });
					}
					resolve(response.data);
				}).catch(async function (e) {
					console.log(e);
					reject(e);
				});
			});
		},
	},
	getters: {
		/**
		 * Returns the currently selected dwelling id from the store
		 * @param {*} state
		 * @returns
		 */
		getDwellingId: state => {
			return state.dwellingId;
		},

		/**
		 * Returns the currently selected staff id from the store
		 * @param {*} state
		 * @returns
		 */
		getStaffId: state => {
			return state.staffId;
		},

		/**
		 * Returns the assignment view geo JSON used to render markers on the map
		 * @param {*} state
		 * @returns
		 */
		getAssignmentGeoJson: state => {
			return state.geoJson;
		},

		/**
		 * Returns the assignment view JSON used to render the lower tables
		 * @param {*} state
		 * @returns
		 */
		getAssignmentTableJson: state => {
			return state.tableJson;
		},

		isCaseAssignmentLoading: (state) => {
			return state.isCaseAssignmentLoading;
		},

		/**
		 * Sets selected case IDs from the map
		 * @param {*} state
		 * @returns
		 */
		selectedCaseIds: (state) => {
			return state.selectedCaseIds;
		},

		getRegionStaff(state, { data }) {
			return state.regionStaff;
		}
	},
	mutations: {

		/**
		 * Sets the value of the currently selected dwelling id for assignment view
		 * @param {*} state
		 * @param {*} data - staff Id
		 */
		setDwellingId(state, { data }) {
			// Vue.set(state, 'dwellingId', data);
			state.dwellingId = data
		},

		/**
		 * Sets the value of the currently selected staff id for assignment view
		 * @param {*} state
		 * @param {*} data - staff Id
		 */
		setStaffId(state, { data }) {
			// Vue.set(state, 'staffId', data);
			state.staffId = data
		},

		/**
		 * Sets the geo JSON used to render markers on the assignment map
		 * @param {*} state
		 * @param {*} data - geo json for the region
		 */
		setAssignmentGeoJson(state, { data }) {
			// Vue.set(state, 'geoJson', data);
			state.geoJson = data
		},

		/**
		 * Sets the JSON used to render the lower table in the assignments view
		 * @param {*} state
		 * @param {*} data - JSON for table data
		 */
		setAssignmentTableJson(state, { data }) {
			// Vue.set(state, 'tableJson', data);
			state.tableJson = data
		},

		setIsCaseAssignmentLoading(state, { data }) {
			// Vue.set(state, 'isCaseAssignmentLoading', data);
			state.isCaseAssignmentLoading = data
		},

		/**
		 * Sets selected case IDs from/for assignment map
		 * @param {*} state
		 * @param {*} param1
		 */
		setSelectedCaseIds(state, { data }) {
			// Vue.set(state, 'selectedCaseIds', data)
			state.selectedCaseIds = data
		},
		setRegionStaff(state, { data }) {
			// Vue.set(state, 'regionStaff', data);
			state.regionStaff = data
		}
	},
	state: {
		dwellingId: '',
		staffId: '',
		geoJson: [],
		tableJson: {},
		isCaseAssignmentLoading: false,
		selectedCaseIds: [],
		regionStaff: []
	}
};

export default assignment;
